module.exports = __webpack_public_path__ + "fonts/Lexend-Light.76e4a02.woff2";